import styled from 'styled-components';
import { Flex } from 'UI/Flex';

export const SButton = styled(Flex)`
  :hover {
    cursor: pointer;
  }
`;
